module.exports = __webpack_public_path__ + "img/withdraw.21277a84.svg";